/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesSpec } from './capabilitiesSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OverriddenCapabilitiesWithServiceTypeSpec { 
    service_type: ServiceTypeEnum;
    overridden_capabilities: CapabilitiesSpec;
}
export namespace OverriddenCapabilitiesWithServiceTypeSpec {
}


